var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPublicEye = function SvgPublicEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18747 6C5.18747 6.46413 5.37184 6.90925 5.70003 7.23744C6.02822 7.56563 6.47334 7.75 6.93747 7.75C7.4016 7.75 7.84672 7.56563 8.17491 7.23744C8.50309 6.90925 8.68747 6.46413 8.68747 6C8.68747 5.53587 8.50309 5.09075 8.17491 4.76256C7.84672 4.43437 7.4016 4.25 6.93747 4.25C6.47334 4.25 6.02822 4.43437 5.70003 4.76256C5.37184 5.09075 5.18747 5.53587 5.18747 6ZM13.7218 5.59688C12.2406 2.47656 10.0015 0.90625 6.99997 0.90625C3.99684 0.90625 1.75934 2.47656 0.278093 5.59844C0.21868 5.72425 0.187866 5.86165 0.187866 6.00078C0.187866 6.13991 0.21868 6.27732 0.278093 6.40312C1.75934 9.52344 3.99841 11.0938 6.99997 11.0938C10.0031 11.0938 12.2406 9.52344 13.7218 6.40156C13.8422 6.14844 13.8422 5.85469 13.7218 5.59688ZM6.93747 8.75C5.41872 8.75 4.18747 7.51875 4.18747 6C4.18747 4.48125 5.41872 3.25 6.93747 3.25C8.45622 3.25 9.68747 4.48125 9.68747 6C9.68747 7.51875 8.45622 8.75 6.93747 8.75Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPublicEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/public-eye.6afba2e8.svg";
export { ForwardRef as ReactComponent };